export const TYPE_MFA_APP = 'app';
export const TYPE_MFA_SMS = 'sms';
export const TYPE_MFA_VOICE = 'voice';

export const mfaTypes = {
    [TYPE_MFA_APP]: 'Authenticator App',
    [TYPE_MFA_SMS]: 'SMS',
    [TYPE_MFA_VOICE]: 'Voice call',
};